import React from "react";
import cx from "clsx";
import PropTypes from "prop-types";
import ReactTooltip from "react-tooltip";
import styles from "./styles.module.scss";

export function Tooltip({
  children,
  id,
  text,
  className,
  withHtmlEntities,
  floating = true,
  clickable,
  delayHide,
  size,
  place,
}) {
  return (
    <>
      <div className={className} data-tip data-for={id}>
        {children}
      </div>
      <ReactTooltip
        id={id}
        effect={floating ? "float" : "solid"}
        html={withHtmlEntities}
        aria-haspopup="true"
        delayHide={delayHide}
        place={place}
        className={cx({
          [styles.clickable]: clickable,
          [styles.large]: size === "lg",
        })}
      >
        {text}
      </ReactTooltip>
    </>
  );
}

Tooltip.propTypes = {
  children: PropTypes.node.isRequired,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  text: PropTypes.string.isRequired,
  className: PropTypes.string,
  size: PropTypes.oneOf(["md", "lg"]),
  place: PropTypes.oneOf(["top", "right", "bottom", "left"]),
};

Tooltip.defaultProps = {
  className: undefined,
  size: "md",
  place: "top",
};
